/* eslint-disable max-len */

import airport24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/airport-24.png';
import beach from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/beach.png';
import bear from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/bear.png';
import bicycle24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/bicycle-24.png';
import binoculars from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/binoculars.png';
import building24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/building-24.png';
import cafe24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/cafe-24.png';
import camera24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/camera-24.png';
import campsite24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/campsite-24.png';
import canoe from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/canoe.png';
import car24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/car-24.png';
import cave from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/cave.png';
import cemetery24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/cemetery-24.png';
import chemist24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/chemist-24.png';
import circle24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/circle-24.png';
import city24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/city-24.png';
import dam24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/dam-24.png';
import danger24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/danger-24.png';
import deer from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/deer.png';
import disability24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/disability-24.png';
import dogPark24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/dog-park-24.png';
import elk from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/elk.png';
import emergencyTelephone24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/emergency-telephone-24.png';
import fastFood24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/fast-food-24.png';
import fireStation24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/fire-station-24.png';
import fish from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/fish.png';
import forest from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/forest.png';
import fuel24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/fuel-24.png';
import garden24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/garden-24.png';
import geyser from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/geyser.png';
import ghostTown from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/ghost-town.png';
import golf24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/golf-24.png';
import grass from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/grass.png';
import groundBlind from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/ground-blind.png';
import harbor24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/harbor-24.png';
import heart24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/heart-24.png';
import heliport24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/heliport-24.png';
import hospital24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/hospital-24.png';
import lake from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/lake.png';
import lighthouse24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/lighthouse-24.png';
import lodging24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/lodging-24.png';
import logging24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/logging-24.png';
import marsh from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/marsh.png';
import mine from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/mine.png';
import minefield24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/minefield-24.png';
import mobilephone24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/mobilephone-24.png';
import moose from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/moose.png';
import mud from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/mud.png';
import museum from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/museum.png';
import number0 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-0.png';
import number1 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-1.png';
import number2 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-2.png';
import number3 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-3.png';
import number4 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-4.png';
import number5 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-5.png';
import number6 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-6.png';
import number7 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-7.png';
import number8 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-8.png';
import number9 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/number-9.png';
import oilWell24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/oil-well-24.png';
import park24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/park-24.png';
import parking24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/parking-24.png';
import peak from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/peak.png';
import petroglyph from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/petroglyph.png';
import picnic from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/picnic.png';
import pitch24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/pitch-24.png';
import playground24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/playground-24.png';
import pollingPlace24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/polling-place-24.png';
import potableWater from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/potable-water.png';
import prison24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/prison-24.png';
import rail24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/rail-24.png';
import rangerStation from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/ranger-station.png';
import reef from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/reef.png';
import restaurant24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/restaurant-24.png';
import resupply from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/resupply.png';
import ruins from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/ruins.png';
import rvPark from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/rv-park.png';
import scat from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/scat.png';
import scrub from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/scrub.png';
import shelter from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/shelter.png';
import skiing24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/skiing-24.png';
import snowflake from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/snowflake.png';
import square24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/square-24.png';
import star24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/star-24.png';
import stone from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/stone.png';
import suitcase24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/suitcase-24.png';
import swimming24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/swimming-24.png';
import toilets24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/toilets-24.png';
import trackDeer from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/track-deer.png';
import trackDog from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/track-dog.png';
import trailCamera from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/trail-camera.png';
import trailhead from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/trailhead.png';
import treeFall from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/tree-fall.png';
import treeStand from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/tree-stand.png';
import triangle24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/triangle-24.png';
import volcano from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/volcano.png';
import water from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/water.png';
import water24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/water-24.png';
import wetland24 from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/wetland-24.png';
import wood from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/wood.png';

export default {
    'airport-24.png': airport24,
    'beach.png': beach,
    'bicycle-24.png': bicycle24,
    'building-24.png': building24,
    'cafe-24.png': cafe24,
    'camera-24.png': camera24,
    'campsite-24.png': campsite24,
    'car-24.png': car24,
    'cemetery-24.png': cemetery24,
    'chemist-24.png': chemist24,
    'circle-24.png': circle24,
    'city-24.png': city24,
    'dam-24.png': dam24,
    'danger-24.png': danger24,
    'disability-24.png': disability24,
    'dog-park-24.png': dogPark24,
    'emergency-telephone-24.png': emergencyTelephone24,
    'fast-food-24.png': fastFood24,
    'fire-station-24.png': fireStation24,
    'fuel-24.png': fuel24,
    'garden-24.png': garden24,
    'golf-24.png': golf24,
    'harbor-24.png': harbor24,
    'heart-24.png': heart24,
    'heliport-24.png': heliport24,
    'hospital-24.png': hospital24,
    'lighthouse-24.png': lighthouse24,
    'lodging-24.png': lodging24,
    'logging-24.png': logging24,
    'minefield-24.png': minefield24,
    'mobilephone-24.png': mobilephone24,
    'oil-well-24.png': oilWell24,
    'park-24.png': park24,
    'parking-24.png': parking24,
    'pitch-24.png': pitch24,
    'playground-24.png': playground24,
    'polling-place-24.png': pollingPlace24,
    'prison-24.png': prison24,
    'rail-24.png': rail24,
    'restaurant-24.png': restaurant24,
    'skiing-24.png': skiing24,
    'square-24.png': square24,
    'star-24.png': star24,
    'suitcase-24.png': suitcase24,
    'swimming-24.png': swimming24,
    'toilets-24.png': toilets24,
    'triangle-24.png': triangle24,
    'water-24.png': water24,
    'wetland-24.png': wetland24,
    bear: bear,
    binoculars: binoculars,
    canoe: canoe,
    cave: cave,
    deer: deer,
    elk: elk,
    fish: fish,
    forest: forest,
    geyser: geyser,
    'ghost-town': ghostTown,
    grass: grass,
    'ground-blind': groundBlind,
    lake: lake,
    marsh: marsh,
    mine: mine,
    moose: moose,
    mud: mud,
    museum: museum,
    'number-0': number0,
    'number-1': number1,
    'number-2': number2,
    'number-3': number3,
    'number-4': number4,
    'number-5': number5,
    'number-6': number6,
    'number-7': number7,
    'number-8': number8,
    'number-9': number9,
    peak: peak,
    petroglyph: petroglyph,
    picnic: picnic,
    'potable-water': potableWater,
    'ranger-station': rangerStation,
    reef: reef,
    resupply: resupply,
    ruins: ruins,
    'rv-park': rvPark,
    scat: scat,
    scrub: scrub,
    shelter: shelter,
    snowflake: snowflake,
    stone: stone,
    'track-deer': trackDeer,
    'track-dog': trackDog,
    'trail-camera': trailCamera,
    trailhead: trailhead,
    'tree-fall': treeFall,
    'tree-stand': treeStand,
    volcano: volcano,
    water: water,
    wood: wood,
};
